import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { CategoryCard } from "./CategoryCard";

const GridWrapper = styled.div`
  width: 100%;
  max-width: 984px;
  overflow-x: auto;
  margin-bottom: 20px;
  height: 136px;
  display: flex;
  gap: 24px;
  justify-content: center;
`;

interface Genre {
  genre_id: number;
  genre_name: string;
}

interface Category {
  imageSrc: string;
  label: string;
  genre_id: number;
}

export const CategoryGrid: React.FC = () => {
  const [categories, setCategories] = useState<Category[]>([]);
  const [loading, setLoading] = useState(true);

  const categoryMappings = [
    { imageSrc: "/media/science_category.svg", label: "НАУКОВІ", searchTerms: ["наук", "science"] },
    { imageSrc: "/media/fiction_category.svg", label: "ХУДОЖНЯ", searchTerms: ["худож", "художня", "novel"] },
    { imageSrc: "/media/self_development_category.svg", label: "САМОРОЗВИТОК", searchTerms: ["саморозвиток", "розвиток", "мотивац", "психолог"] },
    { imageSrc: "/media/adventure_category.svg", label: "ПРИГОДНИЦЬКІ", searchTerms: ["пригод", "adventure", "екшн", "action"] },
    { imageSrc: "/media/poetry_category.svg", label: "ПОЕЗІЯ", searchTerms: ["поез", "poetry", "вірш", "лірика"] },
    { imageSrc: "/media/historical_category.svg", label: "ІСТОРИЧНІ", searchTerms: ["історич", "historical", "історія"] },
    { imageSrc: "/media/fantasy_category.svg", label: "ФЕНТЕЗІ", searchTerms: ["фентезі", "fantasy", "фантаст", "магі"] },
  ];

  useEffect(() => {
    const fetchGenresAndMapCategories = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}/genres`);
        const genres: Genre[] = await response.json();
        
        const mappedCategories: Category[] = [];
        
        categoryMappings.forEach(mapping => {
          const matchedGenre = genres.find(genre => 
            mapping.searchTerms.some(term => 
              genre.genre_name.toLowerCase().includes(term.toLowerCase())
            )
          );
          
          if (matchedGenre) {
            mappedCategories.push({
              imageSrc: mapping.imageSrc,
              label: mapping.label,
              genre_id: matchedGenre.genre_id
            });
          } else {
            mappedCategories.push({
              imageSrc: mapping.imageSrc,
              label: mapping.label,
              genre_id: 0
            });
          }
        });
        
        setCategories(mappedCategories);
      } catch (error) {
        console.error('Помилка при завантаженні жанрів:', error);
        setCategories(categoryMappings.map(mapping => ({
          ...mapping,
          genre_id: 0
        })));
      } finally {
        setLoading(false);
      }
    };

    fetchGenresAndMapCategories();
  }, []);

  if (loading) {
    return (
      <GridWrapper>
        {categoryMappings.map((cat, index) => (
          <CategoryCard key={index} imageSrc={cat.imageSrc} label={cat.label} />
        ))}
      </GridWrapper>
    );
  }

  return (
    <GridWrapper>
      {categories.map((cat, index) => (
        cat.genre_id > 0 ? (
          <Link 
            key={index} 
            to={`/catalog?genre=${cat.genre_id}`}
            style={{ textDecoration: 'none', color: 'inherit' }}
          >
            <CategoryCard imageSrc={cat.imageSrc} label={cat.label} />
          </Link>
        ) : (
          <CategoryCard 
            key={index}
            imageSrc={cat.imageSrc} 
            label={cat.label}
          />
        )
      ))}
    </GridWrapper>
  );
};